import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import EmployeeSalesTargetUserUpdate from '../../components/EmployeeSalesTarget/EmployeeSalesTargetUserUpdate';

const EmployeeSalesTargetUserCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <EmployeeSalesTargetUserUpdate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default EmployeeSalesTargetUserCreatePage;